module.exports = __webpack_public_path__ + "img/putong.27d9745e.png";